module.exports = __webpack_public_path__ + "img/EmissionTracker.77907338.svg";